<template>
  <div class="page_content">
    <job-header :uuid="uuid"></job-header>
    <b-container fluid>
      <b-row class="page-content-section">
        <div class="left-container">
          <div class="job-page-title ace_sec_txt">{{ $tf('reports') }}</div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import JobHeader from './JobHeader'

  export default {
    name: 'jobReports',
    props: ['uuid'],
    components: {
      JobHeader
    }
  }
</script>

<style scoped>
  .page-content-section .left-container {
    float: none;
    width: 100%;
    max-width: 100%;
    margin-top: 0;
  }

  .job-page-title {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobReports.vue